"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const style_1 = require("./style");
function DyanmicTableRow({ children, innerRef, draggableProps, dragHandleProps, isDragging, onClick, }) {
    return (react_1.default.createElement(style_1.StyledTableRow, { onClick: onClick, isDragging: isDragging, ...draggableProps, ...dragHandleProps, ref: innerRef }, children));
}
exports.default = DyanmicTableRow;
